import { ListTableRemodulationRequests } from 'src/pages/remodulationRequests/RemodulationRequests.types';
import React from 'react';
import { useI18n } from 'src/services/i18n/i18n.hooks';
import colors from 'src/style-utils/colors';
import { P } from 'src/style-utils/typographic';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

const AmountColumn: React.FC<ListTableRemodulationRequests> = ({
  OrderAmount,
}) => {
  const {
    formatters: { formatCurrency },
  } = useI18n();

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <P textColor={colors.textTableBody}>
        {formatCurrency(OrderAmount, { removeWhiteSpaces: true })}
      </P>
    </StyleSheetManager>
  );
};

export default AmountColumn;
